import { fg } from '@confluence/feature-gating';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';

import { ContentStatus } from '../constants/ContentStatus';

import { preloadContentDataClassification } from './preloadContentDataClassification';
import { preloadDataClassificationEnabled } from './preloadDataClassificationEnabled';

export async function preloadClassificationContextForViewContent(contentId: string): Promise<any> {
	const queries: Promise<any>[] = [];

	if (fg('disable_classification_enabled_query')) {
		// if the feature flag is enabled, we always preload the content classification
		queries.push(preloadContentDataClassification(contentId, ContentStatus.CURRENT));
		return waitForAllReturnWhenError(queries);
	}

	if (fg('enable_classification_query_async_calls')) {
		queries.push(preloadDataClassificationEnabled());
		queries.push(preloadContentDataClassification(contentId, ContentStatus.CURRENT));
		return waitForAllReturnWhenError(queries);
	}

	const result = await preloadDataClassificationEnabled();
	const isDataClassificationEnabled = result?.data?.isDataClassificationEnabled;

	if (isDataClassificationEnabled) {
		queries.push(preloadContentDataClassification(contentId, ContentStatus.CURRENT));
	}

	return waitForAllReturnWhenError(queries);
}
